__webpack_require__.p = "https://assets-test.sto.cn/sui/sto-super-robot/0.0.6-alpha.2/";